import { MockCard, MockKpiCard } from '../../components/mockups/MockUI'
import { MockStatusBadge } from '../../components/mockups/MockBadge'
import { MockTable } from '../../components/mockups/MockTable'

export function DashboardOverview() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Дашборд менеджера
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Дашборд — главная страница после входа. Показывает ключевые показатели по вашим заявкам и
          клиентам. Все данные обновляются в реальном времени через WebSocket — не нужно
          перезагружать страницу.
        </p>
      </div>

      <div>
        <h3 className="text-base font-medium text-gray-800 dark:text-gray-200 mb-3">
          Структура дашборда
        </h3>
        <MockCard>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm font-medium text-gray-900 dark:text-gray-100">
                  Иванов Пётр
                </div>
                <div className="text-xs text-gray-500">3 клиента · Период: 30 дней</div>
              </div>
              <div className="text-xs text-gray-400">Обновлено: 12:45</div>
            </div>
            <div className="border-t border-gray-100 dark:border-gray-700 pt-3 text-xs text-gray-500 dark:text-gray-400">
              ↑ Шапка: ваше имя, количество клиентов, выбранный период и время обновления
            </div>
          </div>
        </MockCard>
      </div>

      <div>
        <h3 className="text-base font-medium text-gray-800 dark:text-gray-200 mb-3">Навигация</h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Дашборд — первый пункт в боковом меню (иконка сетки). При клике на карточки KPI
          открываются модальные окна с детализацией. Все числа кликабельны.
        </p>
      </div>
    </div>
  )
}

export function DashboardKpi() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          KPI-карточки
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Четыре основных показателя в верхней части дашборда. Каждая карточка — кликабельна,
          открывает модальное окно со списком соответствующих заявок.
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <MockKpiCard value="12" label="Активные заявки" color="brand" />
        <MockKpiCard value="3" label="Просроченные" color="red" />
        <MockKpiCard value="8" label="КП отправлено" color="green" />
        <MockKpiCard value="245 000 ₽" label="Сумма КП за период" color="blue" />
      </div>

      <MockCard>
        <div className="space-y-3 text-sm text-gray-600 dark:text-gray-400">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Что означает каждая карточка:
          </div>
          <ul className="space-y-2 list-none">
            <li>
              <span className="font-medium">📋 Активные заявки</span> — заявки в статусах «Новая»,
              «В работе», «В закупку», «Частично», «Готова к КП». Не включает закрытые и архивные.
            </li>
            <li>
              <span className="font-medium">⏰ Просроченные</span> — заявки с дедлайном, который уже
              прошёл. Выделены красным — требуют немедленного внимания.
            </li>
            <li>
              <span className="font-medium">✅ КП отправлено</span> — заявки, по которым уже
              сформировано и отправлено коммерческое предложение клиенту.
            </li>
            <li>
              <span className="font-medium">💰 Сумма КП</span> — общая сумма всех КП за выбранный
              период (по умолчанию 30 дней).
            </li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function DashboardFunnel() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Воронка продаж
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Левый блок второй строки. Показывает распределение заявок по этапам — от создания до
          закрытия сделки.
        </p>
      </div>

      <MockCard>
        <div className="text-sm font-medium text-gray-800 dark:text-gray-200 mb-3">
          Воронка продаж
        </div>
        <div className="space-y-2">
          {[
            { label: 'Новые', count: 5, width: '100%', color: 'bg-blue-400' },
            { label: 'В работе', count: 8, width: '85%', color: 'bg-orange-400' },
            { label: 'КП готово', count: 4, width: '50%', color: 'bg-green-400' },
            { label: 'КП отправлено', count: 3, width: '35%', color: 'bg-teal-400' },
            { label: 'Сделка', count: 2, width: '20%', color: 'bg-emerald-500' },
          ].map((step) => (
            <div key={step.label} className="flex items-center gap-3">
              <div className="w-28 text-xs text-gray-600 dark:text-gray-400 text-right">
                {step.label}
              </div>
              <div className="flex-1 bg-gray-100 dark:bg-gray-700 rounded-full h-5 overflow-hidden">
                <div
                  className={`${step.color} h-full rounded-full flex items-center justify-end pr-2`}
                  style={{ width: step.width }}
                >
                  <span className="text-xs text-white font-medium">{step.count}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </MockCard>

      <p className="text-sm text-gray-600 dark:text-gray-400">
        Ширина полоски пропорциональна количеству заявок на этом этапе. Идеальная воронка сужается к
        низу — это означает, что заявки проходят все этапы до сделки. Если верхние полоски намного
        шире нижних — заявки «застревают» на ранних этапах.
      </p>
    </div>
  )
}

export function DashboardEvents() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Лента событий
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Правый нижний блок дашборда. Показывает последние действия по вашим заявкам в
          хронологическом порядке. Обновляется в реальном времени — новые события появляются сверху.
        </p>
      </div>

      <MockCard>
        <div className="text-sm font-medium text-gray-800 dark:text-gray-200 mb-3">
          Последние события
        </div>
        <div className="space-y-3">
          {[
            {
              time: '12:45',
              text: 'Квота добавлена по позиции MAX1232',
              who: 'Ольга К.',
              type: 'quote',
            },
            { time: '12:30', text: 'Заявка 17.04.26-3 переведена', who: 'Система', type: 'status' },
            {
              time: '11:15',
              text: 'Комментарий к позиции STM32F103',
              who: 'Алексей П.',
              type: 'comment',
            },
            { time: '10:00', text: 'Создана заявка 17.04.26-4', who: 'Вы', type: 'create' },
          ].map((ev, i) => (
            <div key={i} className="flex gap-3 items-start">
              <div className="text-xs text-gray-400 dark:text-gray-500 w-10 pt-0.5">{ev.time}</div>
              <div className="flex-1">
                <div className="text-sm text-gray-700 dark:text-gray-300">{ev.text}</div>
                <div className="text-xs text-gray-400 dark:text-gray-500">{ev.who}</div>
              </div>
              <MockStatusBadge
                status={
                  ev.type === 'quote'
                    ? 'IN_PROGRESS'
                    : ev.type === 'status'
                      ? 'SENT_TO_PROCUREMENT'
                      : 'NEW'
                }
              />
            </div>
          ))}
        </div>
      </MockCard>

      <MockTable
        caption="Типы событий в ленте"
        columns={[{ header: 'Тип' }, { header: 'Описание' }, { header: 'Пример' }]}
        rows={[
          ['Квота', 'Закупщик добавил котировку по позиции', 'Квота добавлена по MAX1232'],
          ['Статус', 'Изменился статус заявки или позиции', 'Заявка переведена в «В работе»'],
          ['Комментарий', 'Новый комментарий к позиции или заявке', 'Комментарий к STM32F103'],
          ['Создание', 'Создана новая заявка', 'Создана заявка 17.04.26-4'],
        ]}
      />
    </div>
  )
}
